export default "/_next/static/images/img1-88f044cb1a3ffef181bbd7ca1938e048.png";